export function formatMoney(value) {
  if (value == null || isNaN(value)) return null;
  return Number(value).toFixed(2);
}
